import axios from 'axios'
import { HEADER, CAPITALIZEFIRSTLETTER } from '../constants'
import { URL } from '../config'

export default class Gift {
  static INSTANCE = new Gift();

  listGift = [
    {
      name: 'AURICULARES PLEGABLES COLOR PASTEL',
      points: 100,
      image: 'gift1.jpg'
    }
  ];

  Gift() {}

  getListFamily = async (token) => {
    let url = `${URL()}/CvFamilias?source=web`
    return await axios.get(url, HEADER(token)).then(response => {
      const parseResponse = response.data.map(item => {
        return {
          id: item.id,
          name: CAPITALIZEFIRSTLETTER(item.descr.trim())
        }
      })

      return parseResponse
    })
  }
}
